export default __webpack_public_path__ + "static/img_8719-295bb4fb6be6d7512f47f95191628cfe.png";